import React from 'react';
import { ArrowRight, Clock } from 'lucide-react';

export function CallToAction() {
  return (
    <section className="bg-[#07223d] text-white py-20 mt-16 rounded-2xl">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="flex justify-center mb-6">
          <Clock className="w-16 h-16 animate-pulse text-[#e94e38]" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          The "Automation ATM" Secret
          <span className="block mt-2 text-[#fac21c]">
            Helping Average Marketers Sell More Products & Services On Complete Autopilot
          </span>
        </h2>
        <p className="text-xl mb-8 text-blue-100">
          Replace 7+ Marketing Tools With ONE System That Sells For You 24/7...
        </p>
        <a
          href="https://getqualityleadsfast.com/marketing-optin"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#e94e38] text-white px-10 py-5 rounded-lg font-bold text-xl hover:bg-[#d03d29] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          YES, SHOW ME NOW
          <ArrowRight className="w-6 h-6" />
        </a>
        <p className="mt-8 text-[#fac21c] font-medium">
          Smart Marketers Are Already Using This System To Generate More Sales While They Sleep
        </p>
      </div>
    </section>
  );
}